import { NgModule } from '@angular/core';
import {
	AccessCodeModule,
	ContractModule,
	EmailModule,
	FaqModule,
	OrganizationsModule,
	ParksModule,
	PasswordModule,
	ProfileModule,
	RegisterModule,
	ServicesModule,
	SubscriptionModule,
	UserModule,
	UtilsModule,
	VehiclesModule
} from '@spaq/modules';

@NgModule({
	imports: [
		SubscriptionModule.forRoot(),
		ParksModule.forRoot(),
		ContractModule.forRoot(),
		EmailModule.forRoot(),
		ServicesModule.forRoot(),
		UserModule.forRoot(),
		OrganizationsModule.forRoot(),
		AccessCodeModule.forRoot(),
		PasswordModule.forRoot(),
		FaqModule.forRoot(),
		VehiclesModule.forRoot(),
		ProfileModule.forRoot(),
		RegisterModule.forRoot(),
		UtilsModule
	],
	exports: [],
	declarations: []
})
export class FeaturesModule {}
